import axiosInstance from "./BaseService";
import ContentData from "../models/ContentData";

// Fetch all articles with pagination
export const fetchArticles = async (page: number = 1, limit: number = 10): Promise<ContentData[]> => {
  try {
    const response = await axiosInstance.get('/contents', {
      params: { page, limit }
    });
    return response.data.contents || [];
  } catch (error) {
    console.error("Error fetching articles:", error);
    throw error;
  }
};

// Fetch article by ID
export const fetchContentById = async (id: string): Promise<ContentData> => {
  try {
    const response = await axiosInstance.get(`/contents/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching article:", error);
    throw error;
  }
};

// Search content
export const searchContent = async (query: string): Promise<ContentData[]> => {
  try {
    const response = await axiosInstance.get('/contents/search', {
      params: { q: query }
    });
    return response.data.contents || [];
  } catch (error) {
    console.error("Error searching content:", error);
    throw error;
  }
};

// Fetch latest articles by content type
export const fetchLatestContentByType = async (contentTypeName: string, limit: number = 3): Promise<ContentData[]> => {
  try {
    // First get the content type ID
    const contentTypesResponse = await axiosInstance.get('/contenttypes');
    const contentTypes = contentTypesResponse.data;
    const contentType = contentTypes.find((type: any) => 
      type.name.toLowerCase() === contentTypeName.toLowerCase()
    );
    
    if (!contentType) {
      console.warn(`Content type '${contentTypeName}' not found`);
      return [];
    }
    
    // Then fetch content by type ID
    const response = await axiosInstance.get('/contents', {
      params: {
        contentType: contentType._id,
        isActive: true,
        limit,
        sort: '-createdAt'
      }
    });
    
    return response.data.contents || [];
  } catch (error) {
    console.error(`Error fetching ${contentTypeName}:`, error);
    return [];
  }
};

// Fetch articles with pagination by content type
export const fetchContentByTypeWithPagination = async (
  contentTypeName: string, 
  page: number = 1, 
  limit: number = 12
): Promise<{
  contents: ContentData[];
  totalContents: number;
  hasMore: boolean;
  currentPage: number;
}> => {
  try {
    // First get the content type ID
    const contentTypesResponse = await axiosInstance.get('/contenttypes');
    const contentTypes = contentTypesResponse.data;
    const contentType = contentTypes.find((type: any) => 
      type.name.toLowerCase() === contentTypeName.toLowerCase()
    );
    
    if (!contentType) {
      console.warn(`Content type '${contentTypeName}' not found`);
      return { contents: [], totalContents: 0, hasMore: false, currentPage: 1 };
    }
    
    // Then fetch content by type ID with pagination
    const response = await axiosInstance.get('/contents', {
      params: {
        contentType: contentType._id,
        isActive: true,
        page,
        limit,
        sort: '-createdAt'
      }
    });
    
    const data = response.data;
    return {
      contents: data.contents || [],
      totalContents: data.totalContents || 0,
      hasMore: data.hasMore || false,
      currentPage: page
    };
  } catch (error) {
    console.error(`Error fetching ${contentTypeName}:`, error);
    return { contents: [], totalContents: 0, hasMore: false, currentPage: 1 };
  }
};